export enum PaymentAction {
  getPaymentMethods = 'payment/getPaymentMethods',
}
